<template>
  <el-main class="site-content">
    <div class="profile-page">
      <div class="user-info">
        <div class="user-info__inner">
          <div class="user-info__item">
            <div class="user-info__avatar-wrap">
              <img :src="user.avatar ? user.avatar : 'https://via.placeholder.com/330x330'" alt="user_photo"
                   class="user-info__avatar">
            </div>

            <div class="user-info__content">
              <p class="user-info__label label">
                {{ roles.find(el => el.id === user.role_id).name }}
              </p>
              <p class="user-info__text">{{ user.name ? user.name : '&nbsp;' }}</p>
            </div>
          </div>

          <div class="user-info__item">
            <div class="user-info__content">
              <p class="user-info__label label">Организация</p>
              <p class="user-info__text">{{ user.organisation_name ? user.organisation_name : '&nbsp;' }}</p>
            </div>
          </div>
        </div>
      </div>

      <Tabs class="profile-page__tabs container" :selectedIndex="3" @clickOnTitle="profileMenuTabChange">
        <Tab order="1" title="Список ОРК">
          <div class="filter">
            <el-row :gutter="12" type="flex" class="filter__inner mb-16">
              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="ОПД"
                      :value="areasFilter.length ? `Выбрано: ${areasFilter.length} ОПД` : ''"
                      name="areas_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('areas', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="ПС"
                      :value="standardsFilter.length ? `Выбрано: ${standardsFilter.length} ПС` : ''"
                      name="standards_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('standards', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="ПК"
                      :value="qualificationsFilter.length ? `Выбрано: ${qualificationsFilter.length} ПК` : ''"
                      name="qualifications_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('qualifications', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="СПК"
                      :value="orgsFilter.length ? `Выбрано: ${orgsFilter.length} СПК` : ''"
                      name="orgs_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('orgs', 'name')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Разработчик"
                      :value="authorsFilter.length ? `Выбрано: ${authorsFilter.length} ${declOfNumForTable(authorsFilter.length, ['разработчик', 'разработчика', 'разработчиков'])}` : ''"
                      name="authors_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('authors', 'name')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Статус"
                      :value="statusesFilter.length ? `Выбрано: ${statusesFilter.length} ${declOfNumForTable(statusesFilter.length, ['статус', 'статуса', 'статусов'])}` : ''"
                      name="statuses_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('statuses', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <button type="button" class="filter__reset filter__to-right" @click="resetFilters">Сбросить фильтры
                </button>
              </el-col>
            </el-row>

            <el-row :gutter="12" type="flex" class="filter__inner">
              <el-col :span="24">
                <button type="button" class="btn btn_primary filter__to-right" @click="elDialogs.ork = true">Добавить
                  отраслевую рамку квалификаций
                </button>
              </el-col>
            </el-row>
          </div>

          <div class="accordion__item is-parent mt-24">
            <el-table
                cell-class-name="table__cell"
                class="table table_top-scroll"
                header-cell-class-name="table__title pt-0 pb-16"
                ref="table"
                row-key="id"
                :sort-orders="['ascending', 'descending']"
                :data="filteredOrkList"
            >
              <el-table-column
                  width="24"
                  v-if="checkOrkEditables"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.editable" class="table_flex">
                    <el-checkbox @change="handleSelectionChange($event, [scope.row])"/>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  width="48"
                  v-if="checkOrkEditables"
              >
                <template slot="header" slot-scope="scope">
                  <button type="button" class="settings-btn-main" @click="elDialogs.tableSettings = true">
                    <icon-base viewBox="0 0 14 14" class="settings-btn__icon">
                      <icon-settings-main/>
                    </icon-base>
                  </button>
                </template>

                <template v-if="scope.row.editable" slot-scope="scope">
                  <selector-btn :options="accordionTableOptionsForBtn"
                                :params="{ orkListId: scope.row.id, curOrk: scope.row }" portal="selectorModal"
                                @clickOnItem="callback"></selector-btn>
                </template>
              </el-table-column>
              <el-table-column
                  label="Название ОРК"
                  prop="name"
                  sortable
                  :min-width="400"
              >
                <template slot="header" slot-scope="scope">
                  <span v-if="!selection.length">Название ОРК</span>

                  <button type="button" class="btn btn_danger-second btn_small" v-if="selection.length"
                          @click.stop="deleteOrk">
                    Удалить выбранные
                  </button>
                </template>

                <template slot-scope="scope">
                  <a href="#" v-html="scope.row.name" @click.prevent.stop="openORK(scope.row.id)"></a>
                </template>
              </el-table-column>
              <el-table-column
                  label="Количество ОПД"
                  prop="areas"
                  sortable
                  align="center"
                  :width="140"
                  v-if="orksSettings.find((item) => item.name === 'areas' && item.visible)"
              >
                <template slot-scope="scope">
                  <span
                      v-html="scope.row.kinds ? scope.row.kinds.filter(el => el.standard_id !== null).length : 0"></span>
                </template>
              </el-table-column>
              <el-table-column
                  label="Количество ВПД"
                  prop="kinds"
                  sortable
                  align="center"
                  :width="140"
                  v-if="orksSettings.find((item) => item.name === 'kinds' && item.visible)"
              >
                <template slot-scope="scope">
                  <span
                      v-html="scope.row.kinds ? scope.row.kinds.filter(el => el.standard_id !== null).length : 0"></span>
                </template>
              </el-table-column>
              <el-table-column
                  label="Количество ПС"
                  prop="standards"
                  sortable
                  align="center"
                  :width="130"
                  v-if="orksSettings.find((item) => item.name === 'standards' && item.visible)"
              >
                <template slot-scope="scope">
                  <span
                      v-html="scope.row.kinds ? scope.row.kinds.filter(el => el.standard_id !== null).length : 0"></span>
                </template>
              </el-table-column>
              <el-table-column
                  label="Количество ПК"
                  prop="qualifications"
                  sortable
                  align="center"
                  :width="130"
                  v-if="orksSettings.find((item) => item.name === 'qualifications' && item.visible)"
              >
                <template slot-scope="scope">
                  <span v-html="scope.row.qualifications ? scope.row.qualifications.length : 0"></span>
                </template>
              </el-table-column>
              <el-table-column
                  label="Организация разработчика"
                  prop="organisation_name"
                  sortable
                  :width="250"
                  v-if="orksSettings.find((item) => item.name === 'organisation_name' && item.visible)"
              >
                <template slot-scope="scope">
                  <span v-html="scope.row.organisation_name ? scope.row.organisation_name : ''"></span>
                </template>
              </el-table-column>
              <el-table-column
                  label="Статус"
                  prop="status_id"
                  sortable
                  align="center"
                  :width="200"
                  v-if="orksSettings.find((item) => item.name === 'status_id' && item.visible)"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.status_id" class="status"
                        :class="{ [ GET_COLOR_STATUS(scope.row.status_id).cls ]: true }"
                        v-html="findStatusById(scope.row.status_id)"></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </Tab>
        
        <Tab title="Востребованные ПК" v-if="user.role_id === 1" order="2" >

          <div class="filter">
            <el-row :gutter="12" type="flex" class="filter__inner mb-16">
              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="ОПД"
                      :value="areasPkFilter.length ? `Выбрано: ${areasPkFilter.length} ОПД` : ''"
                      name="areasPk_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('areasPk', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="ПС"
                      :value="standardsPkFilter.length ? `Выбрано: ${standardsPkFilter.length} ПС` : ''"
                      name="standardsPk_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('standardsPk', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Востребованность ПК"
                      :value="demandedFilter.length ? 'Востребованная: ' + (demandedFilter.length > 1 ? 'да, нет' : (demandedFilter[0].value ? 'да' : 'нет')) : ''"
                      name="demanded_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('demanded', 'value', false)">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="ПК"
                      :value="qualificationsDFilter.length ? `Выбрано: ${qualificationsDFilter.length} ПК` : ''"
                      name="qualificationsD_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('qualificationsD', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Номер ПК"
                      :value="qualCodesFilter.length ? `Выбрано: ${qualCodesFilter.length} номер(а)` : ''"
                      name="qualCodes_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('qualCodes', 'code')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Уровень ПК"
                      :value="levelPkFilter.length ? `Выбрано: ${levelPkFilter.length} уровней` : ''"
                      name="levelPk_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('levelPk', 'level')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

            </el-row>

            <el-row :gutter="12" type="flex" class="filter__inner mb-16">
              <el-col :span="5">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Срок действия св-ва"
                      :value="qualSrokFilter.length ? `Выбрано: ${qualSrokFilter.length} сроков` : ''"
                      name="qualSrok_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('qualSrok', 'value')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="5">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Квалификационное треб-ние"
                      :value="qualTrebFilter.length ? `Выбрано: ${qualTrebFilter.length} требований` : ''"
                      name="qualTreb_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('qualTreb', 'value')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="5">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Док-ты для проф. экзамена"
                      :value="qualDocsFilter.length ? `Выбрано: ${qualDocsFilter.length} док-тов` : ''"
                      name="qualDocs_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('qualDocs', 'value')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="5">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="ТФ"
                      :value="qualWorkFunctionsFilter.length ? `Выбрано: ${qualWorkFunctionsFilter.length} ТФ` : ''"
                      name="qualWorkFunctions_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('qualWorkFunctions', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="5">
                <div class="input__inner">
                  <input
                      type="text"
                      class="input"
                      placeholder="Образоват. программы"
                      :value="qualProgramsFilter.length ? `Выбрано: ${qualProgramsFilter.length} программ(ы)` : ''"
                      name="qualPrograms_filter"
                  >

                  <button type="submit" class="btn btn_primary input_add-btn"
                          @click.stop="openFilterDialog('qualPrograms', 'id')">
                    <icon-base width="12" height="12" viewBox="0 0 12 12">
                      <icon-action/>
                    </icon-base>
                  </button>
                </div>
              </el-col>

              <el-col :span="3">
                <button type="button" class="filter__reset filter__to-right" @click="resetPkFilters">Сбросить фильтры
                </button>
              </el-col>
            </el-row>
          </div>

          <div class="profile-page-wrapper" :class="{ 'is-panel-open': IS_PANEL_OPEN }">
            <div class="profile-page-wrapper__inner">
              <div class="accordion__item is-parent mt-24">
                <el-table
                    cell-class-name="table__cell"
                    class="table table_top-scroll"
                    header-cell-class-name="table__title pt-0 pb-16"
                    ref="table"
                    row-key="id"
                    :sort-orders="['ascending', 'descending']"
                    :data="filteredDemandedPkList"
                >

                  <el-table-column
                      width="24"
                      v-if="checkDemandedPKEditables"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.editable" class="table_flex">
                        <el-checkbox @change="handleSelectionChangePK($event, [scope.row])"/>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column
                      width="34"
                      v-if="checkDemandedPKEditables"
                  >
                    <!--                <template slot-scope="scope" slot="header">-->
                    <!--                  <button type="button" class="settings-btn-main" @click="elDialogs.tableSettings = true">-->
                    <!--                    <icon-base viewBox="0 0 14 14" class="settings-btn__icon">-->
                    <!--                      <icon-settings-main/>-->
                    <!--                    </icon-base>-->
                    <!--                  </button>-->
                    <!--                </template>-->

                    <template v-if="scope.row.editable" slot-scope="scope">
                      <selector-btn :options="detectActionDemanded(scope.row.is_demanded)"
                                    :params="{ demandedPkListId: scope.row.id, curPKId: scope.row }"
                                    portal="selectorModal"
                                    @clickOnItem="callback"></selector-btn>
                    </template>

                  </el-table-column>

                  <el-table-column width="34">
                    <template v-if="scope.row.is_demanded" slot-scope="scope">
                      <icon-base viewBox="0 0 15 14" v-if="scope.row.is_demanded" class="is_demanded__icon">
                        <icon-demanded/>
                      </icon-base>
                    </template>
                  </el-table-column>

                  <el-table-column
                      label="Название ПК"
                      prop="name"
                      sortable
                      :min-width="400"
                  >
                    <template slot="header" slot-scope="scope">
                      <span v-if="!selectionPK.length">Название ПК</span>

                      <button type="button" class="btn btn_primary-second btn_small" v-if="selectionPK.length"
                              @click.stop="markDemanded">
                        Сделать востребованной

                        <icon-base width="20" height="18" viewBox="-10 0 22 10">
                          <icon-success/>
                        </icon-base>
                      </button>

                      <button type="button" class="btn btn_danger-second btn_small" v-if="selectionPK.length"
                              @click.stop="markNotDemanded">
                        Сделать не востребованной

                        <icon-base width="18" height="18" viewBox="-10 0 24 14">
                          <icon-cancel/>
                        </icon-base>
                      </button>
                    </template>

                    <template slot-scope="scope">
                      <a href="#" v-html="scope.row.name" @click.prevent.stop="openQualification(scope.row.id)"></a>
                    </template>
                  </el-table-column>

                  <el-table-column
                      label="ТФ"
                      prop="functions"
                      sortable
                  >
                    <template slot="header" slot-scope="scope">
                      <span>ТФ</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                      label="Труд.дей"
                      prop="actions"
                      sortable

                  >
                    <template slot="header" slot-scope="scope">
                      <span>Труд.дей</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                      label="Умения"
                      prop="skills"
                      sortable

                  >
                    <template slot="header" slot-scope="scope">
                      <span>Умения</span>
                    </template>
                  </el-table-column>


                  <el-table-column
                      label="Знания"
                      prop="knowledges"
                      sortable

                  >
                    <template slot="header" slot-scope="scope">
                      <span>Знания</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                      label="Обр.прог"
                      prop="programs"
                      sortable

                  >
                    <template slot="header" slot-scope="scope">
                      <span>Обр.прог</span>
                    </template>
                  </el-table-column>

                </el-table>
              </div>
            </div>

            <qualification-panel
                v-if="qualification"
                :read="true"
            />
          </div>
        </Tab>

        <Tab order="3" title="Пользователи" v-if="user.is_admin && user.role_id !== 1">
          <div class="filter">
            <el-row :gutter="12" type="flex" class="filter__inner">
              <!-- <el-col :span="5">
                  <div class="input__inner">
                      <input
                          type="text"
                          class="input"
                          placeholder="Роль"
                          :value="usersRoleFilter.length ? `Выбрано: ${usersRoleFilter.length} ${declOfNumForTable(usersRoleFilter.length, ['роль', 'роли', 'ролей'])}` : ''"
                          name="statuses_filter"
                      >

                      <button type="submit" class="btn btn_primary input_add-btn" @click.stop="openFilterDialog('usersRole', 'id')">
                          <icon-base width="12" height="12" viewBox="0 0 12 12"><icon-action /></icon-base>
                      </button>
                  </div>
              </el-col>

              <el-col :span="5">
                  <div class="input__inner">
                      <input
                          type="text"
                          class="input"
                          placeholder="Организация"
                          :value="usersOrgsFilter.length ? `Выбрано: ${usersOrgsFilter.length} ${declOfNumForTable(usersOrgsFilter.length, ['организация', 'организации', 'организаций'])}` : ''"
                          name="users_orgs_filter"
                      >

                      <button type="submit" class="btn btn_primary input_add-btn" @click.stop="openFilterDialog('usersOrgs', 'name')">
                          <icon-base width="12" height="12" viewBox="0 0 12 12"><icon-action /></icon-base>
                      </button>
                  </div>
              </el-col>

              <el-col :span="5">
                  <button type="button" class="filter__reset" @click="resetUsersFilters">Сбросить фильтры</button>
              </el-col> -->
              <el-col :span="24">
                <button v-if="user.is_admin" type="button" class="btn btn_primary filter__to-right"
                        @click="openUserDialog">Добавить пользователя
                </button>
              </el-col>
            </el-row>
          </div>

          <div class="accordion__item is-parent mt-24">
            <el-table
                cell-class-name="table__cell"
                class="table table_top-scroll"
                header-cell-class-name="table__title pt-0 pb-16"
                ref="table"
                row-key="id"
                :sort-orders="['ascending', 'descending']"
                :data="filteredUsersList"
            >
              <el-table-column
                  v-if="user.is_admin"
                  width="48"
              >
                <template slot-scope="scope">
                  <selector-btn v-if="user.role_id === 1 || scope.row.role_id === 3 || scope.row.role_id === 5"
                                :options="accordionTableUsersOptionsForBtn" :params="{ user: scope.row }"
                                portal="selectorModal" @clickOnItem="callback"></selector-btn>
                </template>
              </el-table-column>
              <el-table-column
                  label="ФИО"
                  prop="name"
                  sortable
                  :min-width="400"
              >
              </el-table-column>
              <el-table-column
                  label="Роль"
                  prop="role"
                  sortable
                  :min-width="200"
              >
                <template slot-scope="scope">
                  {{ roles.find(el => el.id === scope.row.role_id).name }}
                </template>
              </el-table-column>
              <el-table-column
                  label="Организация"
                  prop="organisation_name"
                  sortable
                  :min-width="200"
              >
              </el-table-column>
              <el-table-column
                  label="Почта"
                  prop="email"
                  sortable
                  :min-width="200"
              >
              </el-table-column>
            </el-table>
          </div>
        </Tab>

        <Tab order="4" title="Список организаций" v-if="user.is_admin && user.role_id === 1">
          <template v-if="!activeSPKId">
            <div class="filter">
              <el-row :gutter="12" type="flex" class="filter__inner">
                <el-col :span="24">
                  <button type="button" class="btn btn_primary filter__to-right" @click="openSPKDialog">Добавить
                    организацию
                  </button>
                </el-col>
              </el-row>
            </div>

            <div class="accordion__item is-parent mt-24">
              <el-table
                  cell-class-name="table__cell"
                  class="table table_top-scroll"
                  header-cell-class-name="table__title pt-0 pb-16"
                  ref="table"
                  row-key="id"
                  :sort-orders="['ascending', 'descending']"
                  :data="spk"
              >
                <!--                              ТУТ -->
                <el-table-column
                    width="48"
                    v-if="checkSpkEditables"
                >
                  <template v-if="checkSpkEditables" slot-scope="scope">
                    <selector-btn :options="accordionTableSpkOptionsForBtn" :params="{ spk: scope.row }"
                                  portal="selectorModal" @clickOnItem="callback"></selector-btn>
                  </template>
                </el-table-column>
                <el-table-column
                    label="Название организации"
                    prop="name"
                    sortable
                    :min-width="400"
                >
                  <template slot-scope="scope">
                    <a href="#" v-html="scope.row.name" @click.prevent.stop="activeSPKId = scope.row.id"></a>
                  </template>
                </el-table-column>
                <el-table-column
                    label="Статус организации"
                    prop="is_spk"
                    sortable
                    :min-width="100"
                >
                  <template slot-scope="scope">
                    <span href="#" v-html="scope.row.is_spk === 0 ? 'Организация' : 'СПК'"></span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>

          <template v-if="activeSPKId">
            <div class="filter">
              <el-row :gutter="12" type="flex" class="filter__inner">
                <!-- <el-col :span="5">
                    <div class="input__inner">
                        <input
                            type="text"
                            class="input"
                            placeholder="Роль"
                            :value="usersRoleFilter.length ? `Выбрано: ${usersRoleFilter.length} ${declOfNumForTable(usersRoleFilter.length, ['роль', 'роли', 'ролей'])}` : ''"
                            name="statuses_filter"
                        >

                        <button type="submit" class="btn btn_primary input_add-btn" @click.stop="openFilterDialog('usersRole', 'id')">
                            <icon-base width="12" height="12" viewBox="0 0 12 12"><icon-action /></icon-base>
                        </button>
                    </div>
                </el-col> -->
                <!--
                                                <el-col :span="5">
                                                    <div class="input__inner">
                                                        <input
                                                            type="text"
                                                            class="input"
                                                            placeholder="Организация"
                                                            :value="usersOrgsFilter.length ? `Выбрано: ${usersOrgsFilter.length} ${declOfNumForTable(usersOrgsFilter.length, ['организация', 'организации', 'организаций'])}` : ''"
                                                            name="users_orgs_filter"
                                                        >

                                                        <button type="submit" class="btn btn_primary input_add-btn" @click.stop="openFilterDialog('usersOrgs', 'name')">
                                                            <icon-base width="12" height="12" viewBox="0 0 12 12"><icon-action /></icon-base>
                                                        </button>
                                                    </div>
                                                </el-col> -->

                                <!-- <el-col :span="5">
                                    <button type="button" class="filter__reset" @click="resetUsersFilters">Сбросить фильтры</button>
                                </el-col> -->
                                <el-col :span="24">
                                    <div class="filter__to-right">
                                        <button type="button" class="btn btn_primary" @click="activeSPKId = null">Назад</button>

                    <button type="button" class="btn btn_primary" @click="openUserDialog">Добавить пользователя</button>
                  </div>
                </el-col>
              </el-row>
            </div>

                        <div class="accordion__item is-parent mt-24">
                            <el-table
                                cell-class-name="table__cell"
                                class="table table_top-scroll"
                                header-cell-class-name="table__title pt-0 pb-16"
                                ref="table"
                                row-key="id"
                                :sort-orders="['ascending', 'descending']"
                                :data="filteredUsersList.filter(el => el.spk_id === activeSPKId)"
                            >
                                <el-table-column
                                    v-if="user.is_admin"
                                    width="48"
                                >
                                    <template slot-scope="scope">
                                        <selector-btn :options="scope.row.id !== user.id ? accordionTableUsersOptionsForBtn : accordionTableUsersOptionsForBtnSelf" :params="{ user: scope.row }" portal="selectorModal" @clickOnItem="callback"></selector-btn>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="ФИО"
                                    prop="name"
                                    sortable
                                    :min-width="400"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="Роль"
                                    prop="role"
                                    sortable
                                    :min-width="220"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.role_id ? roles.find(el => el.id === scope.row.role_id).name : '-' }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Организация"
                                    prop="organisation_name"
                                    sortable
                                    :min-width="200"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="Почта"
                                    prop="email"
                                    sortable
                                    :min-width="200"
                                >
                                </el-table-column>
                            </el-table>
                        </div>
                    </template>
                </Tab>

        <!-- <Tab title='Уведомления <sup class="tabs__badge">731</sup>'>
            <div class="filter">
                <el-row :gutter="12" type="flex" class="filter__inner">
                    <el-col :span="4">
                        <v-select class="select" placeholder="Фильтр" :clearable="false" :options="['Специалист', 'Магистр', 'Кандидат наук']">
                            <template #no-options="{ search, searching, loading }">
                                {{ SELECT_NOT_FOUND }}
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes">
                                    <icon-base width="14" height="8" viewBox="0 0 14 8" iconColor="#000"><icon-arrow-down /></icon-base>
                                </span>
                            </template>
                        </v-select>
                    </el-col>
                </el-row>
            </div>

            <div class="accordion__item is-parent mt-24">
                <el-table
                    cell-class-name="table__cell"
                    class="table"
                    header-cell-class-name="table__title pt-0 pb-16"
                    ref="table"
                    row-key="id"
                    :sort-orders="['ascending', 'descending']"
                    :data="mockNotificationsTable"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        width="24"
                        :reserve-selection="true"
                    />

                    <el-table-column
                        width="48"
                    > -->
        <!-- <template slot="header" slot-scope="scope">
            <button type="button" class="settings-btn-main" @click="elDialogs.tableSettings = true">
                <icon-base viewBox="0 0 14 14" class="settings-btn__icon"><icon-settings-main /></icon-base>
            </button>
        </template> -->

        <!-- <template slot-scope="scope">
            <selector-btn :options="accordionTableOptionsForBtn" :params="{ orkListId: scope.row.id }" portal="selectorModal" @clickOnItem="callback"></selector-btn>
        </template>
    </el-table-column>

    <el-table-column
        label="Тема"
        prop="theme"
        sortable
        :min-width="400"
    >
        <template slot="header" slot-scope="scope">
            <span v-if="!selection.length">Название ОРК</span>

            <button type="button" class="btn btn_danger-second btn_small" v-if="selection.length" @click.stop="">
                Удалить выбранные
            </button>

            <button type="button" class="btn btn_primary-second btn_small" v-if="selection.length" @click.stop="">
                Отметить как прочитанные
            </button>
        </template>

        <template slot-scope="scope">
             <accordion class="accordion__table-head">
                <accordion-item :bus="bus" v-on:update:active="scope.row.open = $event">
                    <template #accordion-head>
                        <div>
                            <h4 class="mb-0" v-html="scope.row.theme.name"></h4>
                            <p v-if="!scope.row.open" class="truncate mt-0 mb-0" v-html="scope.row.theme.about"></p>
                        </div>
                    </template>

                    <p class="accordion__body-text mt-0 mb-0" v-html="scope.row.theme.about"></p>
                </accordion-item>
            </accordion>
        </template>
    </el-table-column>

    <el-table-column
        label="Дата"
        prop="data"
        sortable
        min-width="50"
    >
    </el-table-column>
    <el-table-column width="40">
        <template slot-scope="scope">
            <icon-base viewBox="0 0 14 8" class="accordion__arrow ml-0" :class="{'accordion__arrow_active': scope.row.open}">
                <icon-arrow-down />
            </icon-base>
        </template>
    </el-table-column>
</el-table>
</div>
</Tab> -->

        <Tab order="5" title="Настройки">
          <form class="user-settings-form" @submit.prevent="updateUser">
            <div class="user-settings-form__content">
              <div class="user-settings-form__item user-settings-form__item_avatar">
                <div class="user-settings-form__avatar-wrap">
                  <img :src="user.avatar ? user.avatar : 'https://via.placeholder.com/330x330'" alt="user_photo"
                       class="user-settings-form__avatar">
                </div>

                <button type="button" class="btn btn_full mt-16" @click="() => { openCropper = true }">Изменить фото
                </button>
              </div>

              <div class="user-settings-form__item user-settings-form__item_data">
                <h2>Персональные данные</h2>

                <el-row :gutter="24" type="flex">
                  <el-col :span="24">
                    <validate-input v-model="userName" v-bind:error="userNameError"
                                    v-on:update:error="userNameError = $event" type="text" name="name" placeholder="ФИО"
                                    :validateOptions="['empty']"/>
                  </el-col>
                  <!-- <el-col :span="12">
                      <input type="text" name="role" class="input" placeholder="Администратор">
                  </el-col> -->
                </el-row>

                <el-row :gutter="24" type="flex" class="mt-16">
                  <el-col :span="24">
                    <input type="text" name="organisation_name" v-model="userOrganisationName" readonly
                           placeholder="Организация" class="input">
                  </el-col>
                </el-row>

                <el-row :gutter="24" type="flex" class="mt-16">
                  <el-col :span="12">
                    <masked-input name="phone" v-model="userPhone" mask="\+\7 (111) 111-11-11" class="input"
                                  placeholder="Телефон"/>
                  </el-col>

                  <el-col :span="12">
                    <validate-input v-model="userEmail" v-bind:error="userEmailError"
                                    v-on:update:error="userEmailError = $event" type="email" name="email"
                                    placeholder="Email" :validateOptions="['empty', 'email']"/>
                  </el-col>
                </el-row>

                <el-row :gutter="24" type="flex" class="mt-16">
                  <el-col :span="12">
                    <validate-input v-model="userPassword" v-bind:error="userPasswordError"
                                    v-on:update:error="userPasswordError = $event" type="password" name="password"
                                    placeholder="Введите новый пароль" :validateOptions="['password']"
                                    :validateString="userPasswordConfirm"/>
                  </el-col>

                  <el-col :span="12">
                    <validate-input v-model="userPasswordConfirm" v-bind:error="userPasswordError"
                                    v-on:update:error="userPasswordError = $event" type="password"
                                    name="confirm_password" placeholder="Повторите новый пароль"
                                    :validateOptions="['password']" :validateString="userPassword"/>
                  </el-col>
                </el-row>

              </div>

              <!-- <div class="user-settings-form__item user-settings-form__item_notices">
                  <div class="user-notices">
                      <header class="user-notices__head">
                          <h2 class="user-notices__title">Уведомления</h2>
                      </header>

                      <div class="user-notices__content">
                          <ul class="user-notices-list">
                              <li class="user-notices-list__item">
                                  <label class="checkbox">
                                      <input type="checkbox" value="" class="checkbox__input">
                                      <span class="checkbox__helper"></span>
                                      <span class="checkbox__text">Об&nbsp;изменениях ОРК</span>
                                  </label>
                              </li>
                              <li class="user-notices-list__item">
                                  <label class="checkbox">
                                      <input type="checkbox" value="" class="checkbox__input">
                                      <span class="checkbox__helper"></span>
                                      <span class="checkbox__text">Об каком-то изменении</span>
                                  </label>
                              </li>
                              <li class="user-notices-list__item">
                                  <label class="checkbox">
                                      <input type="checkbox" value="" class="checkbox__input">
                                      <span class="checkbox__helper"></span>
                                      <span class="checkbox__text">Об&nbsp;изменениях ОРК</span>
                                  </label>
                              </li>
                              <li class="user-notices-list__item">
                                  <label class="checkbox">
                                      <input type="checkbox" value="" class="checkbox__input">
                                      <span class="checkbox__helper"></span>
                                      <span class="checkbox__text">Об каком-то изменении</span>
                                  </label>
                              </li>
                              <li class="user-notices-list__item">
                                  <label class="checkbox">
                                      <input type="checkbox" value="" class="checkbox__input">
                                      <span class="checkbox__helper"></span>
                                      <span class="checkbox__text">Об&nbsp;изменениях ОРК</span>
                                  </label>
                              </li>
                          </ul>
                      </div>

                      <footer class="user-notices__footer">
                          <label class="checkbox">
                              <input type="checkbox" value="" class="checkbox__input">
                              <span class="checkbox__helper"></span>
                              <span class="checkbox__text">Получать уведомления на&nbsp;почту</span>
                          </label>
                      </footer>
                  </div>
              </div> -->
            </div>

            <footer class="user-settings-form__footer">
              <div class="user-settings-form__footer-item">
                <button type="button" class="btn user-settings-form__btn" @click="logout">Выйти из&nbsp;аккаунта
                </button>
              </div>
              <div class="user-settings-form__footer-item">
                <button type="submit" class="btn btn_action user-settings-form__btn"
                        :disabled="!userName || !userEmail || userEmailError || userPasswordError">Сохранить изменения
                </button>
              </div>
            </footer>
          </form>
        </Tab>
      </Tabs>
    </div>

    <!-- Dialogs -->
    <filter-ork-dialog :activeFilters="activeFilters" :filterBy="filterBy" :filterValue="filterValue"
                       :preloader="filterPreloader" :addedInOrkQualifications="addedInOrkQualifications"
                       :addedInOrkStandards="addedInOrkStandards" :addedInOrkAreas="addedInOrkAreas" :orgs="orgs"
                       :areas="areas" :standards="standards" :qualifications="qualifications" :authors="authors"
                       :statuses="statuses" :usersRole="usersRole" :usersOrgs="usersOrgs"
                       :demanded="demanded" :qualCodes="qualCodes" :levelPk="levelPk"
                       :qualSrok="qualSrok" :qualTreb="qualTreb" :qualDocs="qualDocs"
                       :qualWorkFunctions="qualWorkFunctions" :areasPk="areasPk" :standardsPk="standardsPk"
                       :qualPrograms="qualPrograms" :qualificationsD="qualificationsD" @addFilters="addFilters"/>
    <ork-dialog/>
    <user-dialog v-if="user.is_admin" :activeUser="activeUser"
                 :activeSPKId="user.role_id === 1 ? activeSPKId : user.spk_id"/>
    <spk-dialog :activeSPK="activeSPK"/>
    <ork-rename-dialog :curOrk="orkForEdit"/>
    <table-settings-dialog :settings="orksSettings" @saveTableSettings="changeTableColums"/>
    <avatar-cropper
        v-model="openCropper"
        :upload-handler="cropperHandler"
        :labels="{ submit: 'Сохранить', cancel: 'Отменить' }"
    />
  </el-main>
</template>

<script>
import Vue from 'vue';
import {mapActions, mapGetters, mapState} from 'vuex';

import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import MaskedInput from 'vue-masked-input';
import dialog from '@/mixins/dialog';
import SelectorBtn from '@/components/SelectorBtn';
import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import AvatarCropper from 'vue-avatar-cropper'
import ValidateInput from '@/components/ValidateInput'
import {declOfNum} from '@/helpers';

import OrkDialog from '@/components/Dialogs/OrkDialog'
import UserDialog from '@/components/Dialogs/UserDialog';
import SpkDialog from '@/components/Dialogs/SpkDialog';
import OrkRenameDialog from '@/components/Dialogs/OrkRenameDialog.vue';
import FilterOrkDialog from '@/components/Dialogs/FilterOrkDialog.vue';
import TableSettingsDialog from '@/components/Dialogs/TableSettingsDialog';
import TablePKSettingDialog from '@/components/Dialogs/TablePKSetting';
import QualificationPanel from '@/components/WizardPanels/QualificationPanel';

import constants from '@/constants.js';
import panel from "../mixins/panel";

export default {
  name: 'Profile',
  mixins: [dialog, panel],
  components: {
    MaskedInput,
    Tab,
    Tabs,
    OrkDialog,
    SelectorBtn,
    Accordion,
    AccordionItem,
    AvatarCropper,
    UserDialog,
    SpkDialog,
    ValidateInput,
    OrkRenameDialog,
    FilterOrkDialog,
    TableSettingsDialog,
    TablePKSettingDialog,
    QualificationPanel,
  },
  props: {
    read: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bus: new Vue(),

      selection: [],
      selectionPK: [],
      activeUser: {},
      activeSPK: {},
      activeSPKId: null,
      openCropper: false,
      orkForEdit: {},
      orgs: [],
      areas: [],
      standards: [],
      qualifications: [],
      authors: [],
      statuses: [],
      addedInOrkAreas: [],
      addedInOrkStandards: [],
      addedInOrkQualifications: [],
      usersRole: [],
      usersOrgs: [],
      demanded: [{name: 'Востребованная', value: true} , {name: 'Не востребованная', value: false}],
      qualCodes: [],
      levelPk: [],
      qualSrok: [],
      qualTreb: [],
      qualDocs: [],
      qualWorkFunctions: [],
      workFunctions: [],
      qualPrograms: [],
      areasPk: [],
      standardsPk: [],
      qualificationsD: [],

      userName: '',
      userOrganisationName: '',
      userPhone: '',
      userEmail: '',
      userPassword: '',
      userPasswordConfirm: '',
      userNameError: false,
      userEmailError: false,
      userPasswordError: false,

      activeFilters: [],
      filterBy: '',
      filterValue: '',
      filterPreloader: false,
      areasFilter: [],
      areasPkFilter: [],
      standardsFilter: [],
      standardsPkFilter: [],
      qualificationsFilter: [],
      qualificationsDFilter: [],
      orgsFilter: [],
      authorsFilter: [],
      statusesFilter: [],
      usersRoleFilter: [],
      usersOrgsFilter: [],
      demandedFilter: [],
      qualCodesFilter: [],
      levelPkFilter: [],
      qualSrokFilter: [],
      qualTrebFilter: [],
      qualDocsFilter: [],
      qualWorkFunctionsFilter: [],
      qualProgramsFilter: [],

      demandedPkLoaded: false,

      demandedPKListSettings: [
        {
          name: 'name',
          required: true,
          title: 'Название ПК',
          visible: true,
          default: true
        },
        {
          name: 'ТФ',
          required: true,
          title: 'ТФ',
          visible: false,
          default: false
        }
      ],
      orksSettings: [
        {
          name: 'name',
          required: true,
          title: 'Название ОРК',
          visible: true,
          default: true
        },
        {
          name: 'areas',
          title: 'Количество ОПД',
          visible: false,
          default: false
        },
        {
          name: 'kinds',
          title: 'Количество ВПД',
          visible: false,
          default: false
        },
        {
          name: 'qualifications',
          title: 'Количество ПК',
          visible: true,
          default: true
        },
        {
          name: 'standards',
          title: 'Количество ПС',
          visible: true,
          default: true
        },
        {
          name: 'organisation_name',
          title: 'организация разработчика',
          visible: true,
          default: true
        },
        {
          name: 'status_id',
          title: 'Статус',
          visible: true,
          default: true
        },
      ],
      accordionTablePKActions: [
        {
          name: "Сделать востребованной",
          callback: 'toDemanded',
        },
        {
          name: "Сделать не востребованной",
          callback: 'toDemanded',
          warning: true
        }
      ],
      accordionTableOptionsForBtn: [
        {
          name: 'Редактировать',
          callback: 'editOrk'
        },
        {
          name: 'Удалить',
          warning: true,
          callback: 'deleteOrk'
        },
      ],
      accordionTableSpkOptionsForBtn: [
        {
          name: 'Редактировать',
          callback: 'editSpk'
        },
        {
          name: 'Удалить',
          warning: true,
          callback: 'deleteSpk'
        },
      ],
      accordionTableUsersOptionsForBtn: [
        {
          name: 'Редактировать',
          callback: 'editUser'
        },
        {
          name: 'Удалить',
          warning: true,
          callback: 'deleteUser'
        },
      ],
      accordionTableUsersOptionsForBtnSelf: [
        {
          name: 'Редактировать',
          callback: 'editUser'
        },
      ],
      mockNotificationsTable: [
        {
          theme: {
            name: 'Выполнение работ по неразрушающему контролю (НК) контролируемых объектов (материалов и сварных соединений)',
            about: 'Адживика изоморфна времени. Гегельянство, конечно, транспонирует дуализм. Отношение к современности естественно осмысляет неоднозначный гедонизм и бла бла бла бла бла бла бла'
          },
          data: '21.04.2020',
          open: false
        },
        {
          theme: {
            name: 'Выполнение работ по неразрушающему контролю (НК) контролируемых объектов (материалов и сварных соединений)',
            about: 'Адживика изоморфна времени. Гегельянство, конечно, транспонирует дуализм. Отношение к современности естественно осмысляет неоднозначный гедонизм и бла бла бла бла бла бла бла'
          },
          data: '21.04.2020',
          open: false
        },
        {
          theme: {
            name: 'Выполнение работ по неразрушающему контролю (НК) контролируемых объектов (материалов и сварных соединений)',
            about: 'Адживика изоморфна времени. Гегельянство, конечно, транспонирует дуализм. Отношение к современности естественно осмысляет неоднозначный гедонизм и бла бла бла бла бла бла бла'
          },
          data: '21.04.2020',
          open: false
        },
      ],
        }
    },
    methods: {
      ...mapActions('ork', ['LOAD_ORK', 'DELETE_ORK']),
      ...mapActions('demandedPK', ['LOAD_DEMANDED_PK', 'TO_DEMANDED', 'MARK_DEMANDED', 'MARK_NOT_DEMANDED']),
      ...mapActions('user', [
        'LOAD_USERS',
        'LOAD_ROLES',
        'SAVE_USER_IMAGE',
        'UPDATE_USER',
        'DELETE_USERS',
      ]),
      ...mapActions('tokens', ['LOGOUT']),
      ...mapActions('status', ['LOAD_ORK_STATUSES']),
      ...mapActions('spk', ['LOAD_SPK', 'DELETE_SPK']),
      ...mapActions('editor', [
        'LOAD_QUALIFICATION', 'LOAD_KINDS', 'LOAD_AREAS', 'LOAD_AREAS_NO_ORK', 'LOAD_KINDS_NO_ORK', 'LOAD_QUALIFICATION_NO_ORK',
        'LOAD_STANDARDS_NO_ORK', 'LOAD_WORK_FUNCTIONS_BY_QUALIFICATION_NO_ORK', 'LOAD_PROGRAMS_BY_QUALIFICATION_NO_ORK'
      ]),
      ...mapGetters('editor', [
        'IS_AREAS_EMPTY', 'IS_KINDS_EMPTY', 'IS_STANDARDS_EMPTY'
      ]),

    formatter(row, column) {
      return row.address;
    },
    declOfNumForTable(count, titles) {
      return declOfNum(count, titles)
    },
    detectActionDemanded(isDemanded = false) {
      if (isDemanded) {
        return [this.accordionTablePKActions[1]];
      } else {
        return [this.accordionTablePKActions[0]];
      }
    },
    callback(emitObj) {
      this[emitObj.callback](emitObj.args)
    },
    changeTableColums(settings) {
      this.orksSettings = settings
    },
    changeTableColumnsPK(settings) {
      this.demandedPKListSettings = settings
    },
    async logout() {
      await this.LOGOUT()
      this.$router.push({path: `/`}).catch(() => {
      });
    },
    async updateUser(e) {
      const formData = new FormData(e.target);

      const params = {};

      for (const pair of formData.entries()) {
        if (pair[0] === 'confirm_password' || pair[0].length === 0) continue;
        params[pair[0]] = pair[1];
      }

      await this.UPDATE_USER(params).then(() => {
        this.passwordError = false
        this.userPassword = ''
        this.userPasswordConfirm = ''
      })
    },
    findStatusById(id) {
      return this.statusesOrkList.length ? this.statusesOrkList.find(el => el.id === id).name : '-'
    },
    addFilters({selections, nameFilter}) {
      this[`${nameFilter}Filter`] = selections
    },

    resetFilters() {
      const filtersName = [
        'areas',
        'standards',
        'qualifications',
        'orgs',
        'authors',
        'statuses',
      ]

      filtersName.forEach(el => {
        this[`${el}Filter`] = []
      })
    },

    resetPkFilters() {
      const filtersName = [
        'areasPk',
        'standardsPk',
        'qualificationsD',
        'demanded',
        'qualCodes',
        'levelPk',
        'qualSrok',
        'qualTreb',
        'qualDocs',
        'qualWorkFunctions',
        'qualPrograms',
      ]

      filtersName.forEach(el => {
        this[`${el}Filter`] = []
      })
    },
    resetUsersFilters() {
      const filtersName = [
        'usersRole',
        'usersOrgs',
      ]

      filtersName.forEach(el => {
        this[`${el}Filter`] = []
      })
    },

    openORK(id) {
      this.$router.push({name: 'Editor', params: {id}}).catch(() => {
      });
    },
    openUserDialog() {
      this.activeUser = {}
      this.elDialogs.user = true;
    },
    openSPKDialog() {
      this.activeSPK = {}
      this.elDialogs.spk = true;
    },
    async openFilterDialog(nameFilter, filterValue, needLoad = true) {
      this.filterPreloader = true
      this.activeFilters = this[`${nameFilter}Filter`]
      this.filterBy = nameFilter
      this.filterValue = filterValue
      this.elDialogs.filterOrk = true

      if (this[nameFilter] && needLoad) await this[`load${nameFilter[0].toUpperCase() + nameFilter.slice(1)}`]()

      this.addedInOrkQualifications = Array.from(new Set(this.orkList.map(el => el.qualifications).flat().map(el => el.id)))
      this.addedInOrkStandards = Array.from(new Set(this.orkList.map(el => el.kinds).flat().map(el => el.standard_id)))
      this.addedInOrkAreas = Array.from(new Set(this.orkList.map(el => el.kinds).flat().map(el => el.area_id)))

      this.filterPreloader = false
    },

    handleSelectionChange(event, val) {
      if (event) this.selection = [...val, ...this.selection]
      else this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
    },

    handleSelectionChangePK(event, val) {
      if (event) this.selectionPK = [...val, ...this.selectionPK]
      else this.selectionPK = this.selectionPK.filter(select => !val.find(item => item.id === select.id))
    },

    cropperHandler(cropper) {
      const params = {
        userId: this.user.id,
        data: cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime)
      }
      this.SAVE_USER_IMAGE(params)
    },

    toDemanded(curPK) {
      this.TO_DEMANDED(curPK.demandedPkListId);
    },
    editOrk({curOrk}) {
      this.orkForEdit = curOrk;
      this.elDialogs.orkRename = true;
    },
    editUser({user}) {
      this.activeUser = user
      this.elDialogs.user = true;
    },
    editSpk({spk}) {
      this.activeSPK = spk;
      this.elDialogs.spk = true;
    },

    async markDemanded({demandedPkListId}) {
      if (demandedPkListId) await this.MARK_DEMANDED(demandedPkListId);
      else {
        for (const el of this.selectionPK) {
          await this.MARK_DEMANDED(el.id)
        }
      }

      this.$refs['table'].clearSelection();
    },

    async markNotDemanded({demandedPkListId}) {
      if (demandedPkListId) await this.MARK_NOT_DEMANDED(demandedPkListId);
      else {
        for (const el of this.selectionPK) {
          await this.MARK_NOT_DEMANDED(el.id)
        }
      }

      this.$refs['table'].clearSelection();
    },

    async deleteOrk({orkListId}) {
      if (orkListId) await this.DELETE_ORK(orkListId);
      else {
        for (const el of this.selection) {
          await this.DELETE_ORK(el.id)
        }
      }

      this.$refs['table'].clearSelection();
    },
    deleteSpk({spk}) {
      this.DELETE_SPK(spk.id);
    },
    deleteUser({user}) {
      this.DELETE_USERS(user.id)
    },

    async loadAreas() {
      const tempArr = this.orkList.filter(el => el.kinds !== null).map(el => el.kinds).flat().map(el => el.area)

      this.areas = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el !== null);
    },
    async loadAreasPk() {
      /*const tempArr = [];

      const ids = [];

      for (let i = 0; i < this.demandedPkList.length; i++) {
        let areas = this.demandedPkList[i].areas;

        if (areas != null) {
          for (let j = 0; j < areas.length; j++) {
            if (ids.includes(areas[j].id)) {
              continue;
            }

            tempArr.push({'name': areas[j].name, 'id': areas[j].id});
            ids.push(areas[j].id);
          }
        }
      }

      this.areasPk = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el !== null);*/

      const tempArr = this.orkList.filter(el => el.kinds !== null).map(el => el.kinds).flat().map(el => el.area)

      this.areasPk = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el !== null);
    },
    async loadStandards() {
      const tempArr = this.orkList.filter(el => el.kinds !== null).map(el => el.kinds).flat().map(el => el.standard)

      this.standards = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el !== null);
    },
    async loadStandardsPk() {
      const tempArr = this.orkList.filter(el => el.kinds !== null).map(el => el.kinds).flat().map(el => el.standard)

      this.standardsPk = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el !== null);
    },
    async loadQualifications() {
      const tempArr = this.orkList.filter(el => el.qualifications !== null).map(el => el.qualifications).flat().map(el => {
        return {'name': el.name, 'id': el.id}
      })
      this.qualifications = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse)
    },
    loadOrgs() {
      const tempArr = this.orkList.map(el => {
        return {'name': el.organisation_name}
      })
      this.orgs = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.name !== null);
    },
    loadAuthors() {
      const tempArr = this.orkList.filter(el => el.user !== null).map(el => {
        return {'name': el.user.name, 'id': el.user.id}
      })
      this.authors = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse)
    },
    loadStatuses() {
      this.statuses = JSON.parse(JSON.stringify(this.statusesOrkList))
    },
    loadUsersRole() {
      this.usersRole = JSON.parse(JSON.stringify(this.roles));
    },
    loadUsersOrgs() {
      const tempArr = this.users.map(el => {
        return {'name': el.organisation_name}
      })
      this.usersOrgs = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.name !== null);
    },
    async loadQualCodes() {
      const tempArr = this.demandedPkList.map(el => {
        return {'name': el.code + ' ' + el.name, 'code': el.code }
      })

      this.qualCodes = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.code !== null);
    },
    async loadLevelPk() {
      const tempArr = this.demandedPkList.map(el => {
        return {'name': el.level, 'level': el.level }
      })

      tempArr.sort(function(a, b) {
        return a.level - b.level;
      });

      this.levelPk = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.level !== null);
    },
    async loadQualSrok() {
      const tempArr = this.demandedPkList.map(el => {
        return {'name': el.srok, 'value': el.srok }
      })

      /*tempArr.sort(function(a, b) {
        return a.value - b.value;
      });*/

      this.qualSrok = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.value !== null);
    },
    async loadQualTreb() {
      const tempArr = this.demandedPkList.map(el => {
        return {'name': el.requirement, 'value': el.requirement }
      })

      this.qualTreb = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.value !== null);
    },
    async loadQualDocs() {
      const tempArr = [];

      for (let i = 0; i < this.demandedPkList.length; i++) {
        let docs = this.demandedPkList[i].docs;

        if (docs != null) {
          for (let j = 0; j < docs.length; j++) {
            tempArr.push({'name': docs[j], 'value': docs[j]});
          }
        }
      }

      this.qualDocs = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.value !== null);
    },
    async loadQualWorkFunctions() {
      await this.loadAllWorkFunctions();

      const tempArr = this.workFunctions;

      this.qualWorkFunctions = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.name !== null);
    },

    loadAllWorkFunctions() {
      if (this.workFunctions == undefined || this.workFunctions.length == 0) {

        for (let i = 0; i < this.demandedPkList.length; i++) {
          let functions_array = this.demandedPkList[i].functions_array;

          if (functions_array != null) {
            for (let j = 0; j < functions_array.length; j++) {
              this.workFunctions.push({'name': functions_array[j].name, 'id': functions_array[j].id});
            }
          }
        }
      }
    },
    async loadQualificationsD() {
      const tempArr = this.demandedPkList.map(el => {
        return {'name': el.name, 'id': el.id}
      });

      this.qualificationsD = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.name !== null);
    },

    async loadQualPrograms() {
      const tempArr = [];

      for (let i = 0; i < this.demandedPkList.length; i++) {
        let programs_array = this.demandedPkList[i].programs_array;

        if (programs_array != null) {
          for (let j = 0; j < programs_array.length; j++) {
            tempArr.push({'name': programs_array[j].name, 'id': programs_array[j].id});
          }
        }
      }

      this.qualPrograms = [...new Set(tempArr.map(JSON.stringify))].map(JSON.parse).filter(el => el.name !== null);
    },

    async openQualification(id) {
      if (this.IS_AREAS_EMPTY()) {
        await this.LOAD_AREAS_NO_ORK();
      }

      if (this.IS_KINDS_EMPTY()) {
        await this.LOAD_KINDS_NO_ORK();
      }

      if (this.IS_STANDARDS_EMPTY()) {
        await this.LOAD_STANDARDS_NO_ORK();
      }

      await this.LOAD_WORK_FUNCTIONS_BY_QUALIFICATION_NO_ORK(id);

      await this.LOAD_PROGRAMS_BY_QUALIFICATION_NO_ORK(id);

      await this.LOAD_QUALIFICATION_NO_ORK(id);

      this.elPanels.qualification = 1;
    },
    profileMenuTabChange(currentIndex) {
      if (currentIndex === 1 && !this.demandedPkLoaded) {
        this.LOAD_DEMANDED_PK()
        this.demandedPkLoaded = true
      }
    },
  },
  computed: {
    ...mapState('tokens', ['accessToken']),
    ...mapState('listsForEditor', ['qualificationsList']),
    ...mapState('user', ['user', 'users', 'roles']),
    ...mapState('ork', ['orkList']),
    ...mapState('demandedPK', ['demandedPkList']),
    ...mapState('status', ['statusesOrkList']),
    ...mapState('spk', ['spk']),
    ...mapGetters('status', ['GET_COLOR_STATUS']),
    ...mapState('common', ['dialogs', 'panels']),
    ...mapState('editor', ['qualification']),
    ...mapGetters('common', ['IS_PANEL_OPEN']),

    filteredDemandedPkList() {
      return this.demandedPkList.filter(demandedPK => {
        let res = true
        let filteredData = [
          {
            filter: this.areasPkFilter,
            filterItem: 'id',
            filteredElement: 'areas',
          },
          {
            filter: this.standardsPkFilter,
            filterItem: 'id',
            filteredElement: 'standards',
          },
          {
            filter: this.qualificationsDFilter,
            filterItem: 'id',
            filteredElement: 'id',
          },
          {
            filter: this.demandedFilter,
            filterItem: 'value',
            filteredElement: 'is_demanded'
          },
          {
            filter: this.qualCodesFilter,
            filterItem: 'code',
            filteredElement: 'code'
          },
          {
            filter: this.levelPkFilter,
            filterItem: 'level',
            filteredElement: 'level'
          },
          {
            filter: this.qualSrokFilter,
            filterItem: 'value',
            filteredElement: 'validity'
          },
          {
            filter: this.qualTrebFilter,
            filterItem: 'value',
            filteredElement: 'requirement'
          },
          {
            filter: this.qualDocsFilter,
            filterItem: 'value',
            filteredElement: 'docs'
          },
          {
            filter: this.qualWorkFunctionsFilter,
            filterItem: 'id',
            filteredElement: ['functions_array', 'id'],
            isArray: true
          },
          {
            filter: this.qualProgramsFilter,
            filterItem: 'id',
            filteredElement: ['programs_array', 'id'],
            isArray: true
          },
        ]

        filteredData.forEach(data => {
          if (res && data.filter.length > 0) {
            try {
              if (data.isArray) {
                if (data.filteredElement.length === 3) {
                  if (!!data.filter.find(filterItem => demandedPK[data.filteredElement[0]].find(findItem => findItem[data.filteredElement[1]][data.filteredElement[2]] === filterItem[data.filterItem]))) res = true
                  else res = false
                } else {
                  if (!!data.filter.find(filterItem => demandedPK[data.filteredElement[0]].find(findItem => findItem[data.filteredElement[1]] === filterItem[data.filterItem]))) res = true
                  else res = false
                }
              } else {
                if (!!data.filter.find(filterItem => filterItem[data.filterItem] == demandedPK[data.filteredElement] || (Array.isArray(demandedPK[data.filteredElement]) && demandedPK[data.filteredElement].includes(filterItem[data.filterItem])))) res = true
                else res = false
              }
            } catch (e) {
              res = false;
            }
          }
        })

        return res
      })
    },
    filteredOrkList() {
      return this.orkList.filter(ork => {
        let res = true
        let filteredData = [
          {
            filter: this.areasFilter,
            filterItem: 'id',
            filteredElement: ['kinds', 'area', 'id'],
            isArray: true
          },
          {
            filter: this.standardsFilter,
            filterItem: 'id',
            filteredElement: ['kinds', 'standard', 'id'],
            isArray: true
          },
          {
            filter: this.qualificationsFilter,
            filterItem: 'id',
            filteredElement: ['qualifications', 'id'],
            isArray: true,
          },
          {
            filter: this.orgsFilter,
            filterItem: 'name',
            filteredElement: 'organisation_name'
          },
          {
            filter: this.authorsFilter,
            filterItem: 'id',
            filteredElement: ['user', 'id'],
            isObject: true
          },
          {
            filter: this.statusesFilter,
            filterItem: 'id',
            filteredElement: 'status_id'
          },
        ]

        filteredData.forEach(data => {
          if (res && data.filter.length > 0) {
            try {
              if (data.isArray) {
                if (data.filteredElement.length === 3) {
                  if (!!data.filter.find(filterItem => ork[data.filteredElement[0]].find(findItem => findItem[data.filteredElement[1]][data.filteredElement[2]] === filterItem[data.filterItem]))) res = true
                  else res = false
                } else {
                  if (!!data.filter.find(filterItem => ork[data.filteredElement[0]].find(findItem => findItem[data.filteredElement[1]] === filterItem[data.filterItem]))) res = true
                  else res = false
                }
              } else if (data.isObject) {
                if (!!data.filter.find(filterItem => ork[data.filteredElement[0]] !== null && filterItem[data.filterItem] == ork[data.filteredElement[0]][data.filteredElement[1]])) res = true
                else res = false
              } else {
                if (!!data.filter.find(filterItem => filterItem[data.filterItem] == ork[data.filteredElement])) res = true
                else res = false
              }
            } catch (e) {
              res = false
            }
          }
        })

        return res
      })
    },
    filteredUsersList() {
      return this.users.filter(user => {
        let res = true
        let filteredData = [
          {
            filter: this.usersRoleFilter,
            filterItem: 'id',
            filteredElement: 'role_id'
          },
          {
            filter: this.usersOrgsFilter,
            filterItem: 'name',
            filteredElement: 'organisation_name'
          },
        ]

        filteredData.forEach(data => {
          if (res && data.filter.length > 0) {
            if (!!data.filter.find(filterItem => filterItem[data.filterItem] == user[data.filteredElement])) res = true
            else res = false
          }
        })

        return res
      })
    },
    checkOrkEditables() {
      return !!this.filteredOrkList.find(el => el.editable === true)
    },
    checkDemandedPKEditables() {
      return !!this.filteredDemandedPkList.find(el => el.editable === true)
    },
    checkSpkEditables() {
      return this.user.is_admin;
    }
  },
  /*watch: {
    'elPanels.qualification': function(val) {
      this.hasFooter = !val
      if (val === 1) this.hintsCode = 'QualificationsPanel'
      else if (val === 2) this.hintsCode = 'WorkFunctionsQualifications'
      else this.hintsCode = 'QualificationsStep'
    }
  },*/
  async mounted() {
    await this.LOAD_ORK()
    await this.LOAD_USERS()
    // this.LOAD_DEMANDED_PK()
    await this.LOAD_SPK()
    await this.LOAD_ORK_STATUSES()
    await this.LOAD_ROLES()

    this.userName = this.user.name
    this.userOrganisationName = this.user.organisation_name
    this.userPhone = this.user.phone
    this.userEmail = this.user.email
  },
  created() {
    this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
  }
}
</script>
